namespace Matrix.Dashboards {
    export interface DashboardItem {
        WidgetType?: string;
        WidgetOptions?: { [key: string]: any };
        LayoutX?: number;
        LayoutY?: number;
        LayoutW?: number;
        LayoutH?: number;
        Collapsed?: boolean;
    }
}
